import React from 'react';

import GrowDiagonalIcon from '@atlaskit/icon/core/grow-diagonal';

import { PanelAction } from '../../panel-action/panel-action';
import type { PanelActionProps } from '../../panel-action/types';

export interface PanelActionExpandProps extends Pick<
	PanelActionProps,
	'onClick' | 'testId' | 'label'
> {}

/**
 * The PanelActionExpand component provides an expand action button
 * for opening panels in full-screen modal experiences.
 */
export function PanelActionExpand({
	onClick,
	testId,
	label,
}: PanelActionExpandProps): React.JSX.Element {
	return (
		<PanelAction
			onClick={onClick}
			testId={testId}
			icon={GrowDiagonalIcon}
			label={label || 'Expand panel'}
		/>
	);
}
